module.exports = __webpack_public_path__ + "static/img/user.452c525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v3/img/icons/user.png
// module id = j6rm
// module chunks = 10